module.exports = __webpack_public_path__ + "static/img/MacBookPro15_2.96d051b5.png";